import { useNavigate } from "react-router-dom";

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="flex h-screen flex-col items-center justify-center gap-6">
            <h1 className="text-7xl font-bold">404</h1>
            <p className="text-lg text-muted-foreground">페이지를 찾을 수 없습니다.</p>
            <button type="button" className="px-4 py-2 text-white bg-[#0A7AFF] rounded-md" onClick={() => navigate(-1)}>
                이전 페이지로 돌아가기
            </button>
        </div>
    );
}
